import { Validators, AbstractControl } from '@angular/forms';
import * as Utils from '@shared/core/utils';
import { ILoyaltyAppCountryAssignmentModel } from '@shared/state';

export const cellPhoneCountryValidator = (
    countryIdField: string,
    countries: ILoyaltyAppCountryAssignmentModel[] = [],
    fallbackMinLength: number = 10,
    fallbackMaxLength: number = 10
) => (control: AbstractControl): OLO.Common.IValidators => {
    if (control.parent === undefined) return null;

    const fallback = (): OLO.Common.IValidators => {
        /* Fallback */
        const maxlength = Validators.maxLength(fallbackMaxLength)(control);
        const minlength = Validators.minLength(fallbackMinLength)(control);
        const form = Utils.ValidatorsUtils.findRoot(control);

        // console.warn(`countryIdField "${countryIdField}" is not defined in current control form or countries are not defined in config.js:`,
        //     countries, form, `Fallback used with minlength ${fallbackMinLength} and maxlength ${fallbackMaxLength} validators`);
        return maxlength || minlength;
    };

    if (!countryIdField || !countries || countries.length === 0) {
        return fallback();
    }

    const countryIdControl: AbstractControl = Utils.ValidatorsUtils.findControl(countryIdField, control);
    if (!countryIdControl) {
        return fallback();
    }
    if (!countryIdControl.value) return { cellPhoneContryError: { message: 'Invalid country prefix', value: countryIdControl.value }, value: countryIdControl.value };

    const foundCountry: ILoyaltyAppCountryAssignmentModel = countries.find(obj => obj.Id === countryIdControl.value);
    if (!foundCountry) return { cellPhoneContryError: { message: 'Setup issue. Country is not defined', value: countryIdControl.value }, value: countryIdControl.value };

    /* Main checks */
    if (control.value.length < foundCountry.MinLength) return { minlength: { requiredLength: foundCountry.MinLength, actualLength: control.value.length } };
    if (control.value.length > foundCountry.MaxLength) return { maxlength: { requiredLength: foundCountry.MaxLength, actualLength: control.value.length } };

    return null;
};
